var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnterLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 592V80c0-26.467 21.532-48 48-48h32c26.468 0 48 21.533 48 48v160c0 8.836-7.163 16-16 16s-16-7.164-16-16V80c0-8.822-7.178-16-16-16H48c-8.822 0-16 7.178-16 16v512c0 8.822 7.178 16 16 16h32c8.822 0 16-7.178 16-16V432c0-8.837 7.163-16 16-16s16 7.163 16 16v160c0 26.468-21.532 48-48 48H48c-26.468 0-48-21.532-48-48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.312 507.312c6.248-6.247 6.248-16.379 0-22.627L134.628 352H592c8.836 0 16-7.164 16-16s-7.164-16-16-16H134.628l132.684-132.686c6.248-6.249 6.248-16.379 0-22.628-6.247-6.248-16.379-6.248-22.627 0l-160 160C81.562 327.811 80 331.905 80 336s1.562 8.189 4.688 11.314l160 160c6.247 6.248 16.377 6.248 22.624-.002z"
  })));
}

export default SvgEnterLeft;